/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import numeral from 'numeral'
import VeeValidate from 'vee-validate'
import VueSweetAlert from 'vue-sweetalert'
Vue.use(VueSweetAlert)

import store from './store'

Vue.use(VueI18n)
Vue.use(ElementUI)
window.moment = require('moment')
// Finding user's language.
const language = window.Config.LOCALE
const segments = language.split('_')

window.currentLang = _.head(segments)
window.currentLocale = segments.join('-')

// Create VueI18n instance with options
import messages from './messages'

const i18n = new VueI18n({
  locale: currentLang,
  messages
})

Vue.filter('number', function (number, format) {
  return numeral(number).format('0,0[.]00')
})
Vue.filter('positiveInteger', function (value) {
  var number = +value.replace(/[^\d.]/g, '')
  return isNaN(number) ? 0 : parseFloat(number.toFixed())
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/') + (parseInt(moment(String(value)).format('YYYY')) + 543) + moment(String(value)).format(' HH:mm')
  }
})
Vue.filter('fullFormatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/') + (parseInt(moment(String(value)).format('YYYY')) + 543) + moment(String(value)).format(' HH:mm:ss')
  }
})

const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: {
    en: {
      messages: {
        required: function () { return 'กรุณากรอกตัวเลข 5 หลัก' },
        numeric: function () { return 'กรุณากรอกตัวเลขเท่านั้น' },
        digits: function (digits, number) { return 'กรุณากรอกตัวเลชให้ครบ ' + number + ' หลัก' }
      },
      attributes: {
        ykn: 'ตัวเลข'
      }
    }
  },
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
}

Vue.use(VeeValidate, config)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('direct-message', require('../admin/components/DirectMessage'))
Vue.component('lotto', require('./pages/Game'))

const app = new Vue({
  el: '#app',
  store,
  i18n
  // store,
  // mounted () {
  //   this.fetchAuthUser()
  // },
  // methods: {
  //   ...mapActions('auth', [
  //     'fetchAuthUser'
  //   ])
  // }
})



// WEBPACK FOOTER //
// ./resources/assets/js/lotto/index.js